import DatosPersonalesCabeza from '../components/Caracterizacion/Diagnostico/DatosPersonalesCabeza';
import DatosPersonalesHogar from '../components/Caracterizacion/Diagnostico/DatosPersonalesHogar';
import DiagnosticoUbicacion from '../components/Caracterizacion/Diagnostico/DiagnosticoUbicacion';
import DiagnosticoDesplazamiento from '../components/Caracterizacion/Diagnostico/DiagnosticoDesplazamiento';
import DiagPerdidasBienes from '../components/Caracterizacion/Diagnostico/DiagPerdidasBienes';
import DiagPerdidasOtras from '../components/Caracterizacion/Diagnostico/DiagPerdidasOtras';
import DiagnosticoDeudas from '../components/Caracterizacion/Diagnostico/DiagnosticoDeudas';
import DiagUnidadFamiliar from '../components/Caracterizacion/Diagnostico/DiagUnidadFamiliar';
import DiagVidaLibertad from '../components/Caracterizacion/Diagnostico/DiagVidaLibertad';
import DiagnosticoRetorno from '../components/Caracterizacion/Diagnostico/DiagnosticoRetorno';
import DiagnosticoRetornoXIntegrante from '../components/Caracterizacion/Diagnostico/DiagnosticoRetornoXIntegrante';
import DiagSeguridadAlimentaria from '../components/Caracterizacion/Diagnostico/DiagSeguridadAlimentaria';
import DiagnosticoAutonomia from '../components/Caracterizacion/Diagnostico/DiagnosticoAutonomia';
import DiagAutonomiaFormacion from '../components/Caracterizacion/Diagnostico/DiagAutonomiaFormacion';
import DiagnosticoAlbergue from '../components/Caracterizacion/Diagnostico/DiagnosticoAlbergue';
import DiagSeguimientoRetorno from '../components/Caracterizacion/Diagnostico/DiagSeguimientoRetorno';


export const DiagnosticoRoutes = [
    { path: 'diagnosticos/datospersonalescabeza', element: <DatosPersonalesCabeza /> },
    { path: 'diagnosticos/datospersonaleshogar', element: <DatosPersonalesHogar /> },
    { path: 'diagnosticos/ubicacion', element: <DiagnosticoUbicacion /> },
    { path: 'diagnosticos/desplazamiento', element: <DiagnosticoDesplazamiento /> },
    { path: 'diagnosticos/perdidasbienes', element: <DiagPerdidasBienes /> },
    { path: 'diagnosticos/perdidasotras', element: <DiagPerdidasOtras /> },
    { path: 'diagnosticos/deudas', element: <DiagnosticoDeudas /> },
    { path: 'diagnosticos/unidadfamiliar', element: <DiagUnidadFamiliar /> },
    { path: 'diagnosticos/vidalibertad', element: <DiagVidaLibertad /> },
    { path: 'diagnosticos/retorno', element: <DiagnosticoRetorno /> },
    { path: 'diagnosticos/retornoxintegrantes', element: <DiagnosticoRetornoXIntegrante /> },
    { path: 'diagnosticos/seguridadalimentaria', element: <DiagSeguridadAlimentaria /> },
    { path: 'diagnosticos/autonomia', element: <DiagnosticoAutonomia /> },
    { path: 'diagnosticos/autonomiaformacion', element: <DiagAutonomiaFormacion /> },
    { path: 'diagnosticos/albergue', element: <DiagnosticoAlbergue /> },
    { path: 'diagnosticos/seguimientoretorno', element: <DiagSeguimientoRetorno /> },
];